var _g, _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGmSeenFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 24,
    r: 21,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3224 29.7275L15.6175 34.3997C15.5355 34.5363 15.5902 34.6456 15.6175 34.7002C15.6448 34.7549 15.7268 34.8642 15.8907 34.8369L18.4317 34.7002C18.7596 34.7002 19.0602 34.8642 19.2241 35.1647L20.3716 37.4325C20.4536 37.5691 20.5629 37.5964 20.6175 37.5964C20.7268 37.5964 20.8088 37.5418 20.8634 37.4598L23.4318 32.9243C21.4372 32.3505 19.6612 31.2303 18.3224 29.7275Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3008 22.6238C36.3008 17.0773 31.7652 12.5417 26.2187 12.5417C20.6723 12.5417 16.1367 17.0773 16.1367 22.6238C16.1367 28.1703 20.6723 32.7058 26.2187 32.7058C31.7652 32.7058 36.3008 28.1976 36.3008 22.6238ZM26.2187 30.8479C21.6832 30.8479 17.9947 27.1593 17.9947 22.6238C17.9947 18.0882 21.6832 14.3997 26.2187 14.3997C30.7543 14.3997 34.4428 18.0882 34.4428 22.6238C34.4428 27.1593 30.7543 30.8479 26.2187 30.8479Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6114 20.5926L28.829 20.1909C28.4599 20.1335 28.1476 19.9039 28.0056 19.5883L26.7564 17.0344C26.6712 16.8335 26.4724 16.7188 26.2737 16.7188C26.0749 16.7188 25.8762 16.8335 25.791 17.0344L24.5417 19.5883C24.3714 19.9326 24.0591 20.1622 23.7184 20.1909L20.9359 20.5926C20.7372 20.6213 20.5668 20.7648 20.51 20.9656C20.4533 21.1665 20.51 21.3674 20.652 21.5396L22.6679 23.5195C22.9234 23.7778 23.037 24.1508 22.9802 24.5239L22.4975 27.336C22.4691 27.5369 22.5543 27.7377 22.7246 27.8812C22.895 27.996 23.1221 28.0247 23.2925 27.9099L25.791 26.5899C26.1033 26.4177 26.5008 26.4177 26.8131 26.5899L29.3117 27.9099C29.5104 27.996 29.7092 27.996 29.8795 27.8812C30.0499 27.7664 30.135 27.5656 30.1066 27.336L29.624 24.5239C29.5672 24.1508 29.6808 23.7778 29.9363 23.5195L31.9521 21.5396C32.0941 21.3961 32.1509 21.1665 32.0941 20.9656C31.9805 20.7648 31.8102 20.6213 31.6114 20.5926Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1406 29.7275C32.8291 31.203 31.0805 32.2959 29.1133 32.8696L31.5723 37.4052C31.627 37.5145 31.7362 37.5691 31.8182 37.5691C31.9275 37.5691 32.0095 37.5145 32.0641 37.4052L33.2117 35.1647C33.3483 34.8642 33.6761 34.7002 34.004 34.7002L36.545 34.8369C36.709 34.8642 36.7909 34.7549 36.8182 34.7002C36.8456 34.6456 36.9002 34.5363 36.8182 34.3997L34.1406 29.7275Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3104 20.875C32.1738 20.4925 31.8459 20.2192 31.4361 20.1373L28.7585 19.7548C28.5946 19.7274 28.4306 19.6181 28.376 19.4815L27.1738 17.0498C26.9825 16.6946 26.6273 16.4487 26.2175 16.4487C25.8077 16.4487 25.4525 16.6673 25.2612 17.0498L24.059 19.4815C23.977 19.6455 23.8404 19.7548 23.6765 19.7548L20.9989 20.1373C20.589 20.1919 20.2612 20.4651 20.1246 20.875C19.9879 21.2848 20.0972 21.6947 20.3978 21.9679L22.3377 23.8531C22.4743 23.9624 22.5289 24.1537 22.5016 24.3176L22.0371 26.9952C21.9552 27.4051 22.1191 27.7876 22.4743 28.0335C22.6656 28.1701 22.8841 28.2521 23.1027 28.2521C23.2667 28.2521 23.4306 28.2248 23.5945 28.1155L25.9989 26.8586C26.1628 26.7767 26.3268 26.7767 26.4907 26.8586L28.8951 28.1155C29.2503 28.3067 29.6875 28.2794 30.0153 28.0335C30.3432 27.7876 30.5071 27.4051 30.4525 26.9952L29.9607 24.345C29.9334 24.181 29.988 23.9898 30.0973 23.8805L32.0372 21.9952C32.3377 21.6947 32.447 21.2848 32.3104 20.875ZM31.682 21.5854L29.7421 23.4706C29.4962 23.7165 29.3869 24.0717 29.4416 24.4269L29.906 27.1045C29.9334 27.2958 29.8514 27.487 29.6875 27.6237C29.5235 27.733 29.3049 27.7603 29.141 27.651L26.7366 26.3941C26.4361 26.2302 26.0536 26.2302 25.753 26.3941L23.3486 27.651C23.1574 27.733 22.9661 27.733 22.8022 27.6237C22.6382 27.5144 22.5563 27.3231 22.5836 27.1045L23.0481 24.4269C23.1027 24.0717 22.9934 23.7165 22.7475 23.4706L20.8076 21.5854C20.671 21.4488 20.6164 21.2302 20.671 21.0389C20.7257 20.8477 20.8896 20.7111 21.0808 20.6837L23.7585 20.3012C24.1137 20.2466 24.4142 20.028 24.5508 19.7274L25.753 17.2957C25.835 17.1045 26.0262 16.9952 26.2175 16.9952C26.4087 16.9952 26.6 17.1045 26.682 17.2957L27.8842 19.7274C28.0481 20.0553 28.3486 20.2739 28.6765 20.3012L31.3541 20.6837C31.5454 20.7111 31.7093 20.8477 31.764 21.0389C31.8733 21.2575 31.8186 21.4488 31.682 21.5854Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.5742,
    y1: 29.7275,
    x2: 23.7147,
    y2: 30.0321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C78D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#CF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#F3C36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F3C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9B559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#CE9326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16.1367,
    y1: 12.5417,
    x2: 37.0268,
    y2: 13.3243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C78D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#CF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#F3C36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F3C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9B559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#CE9326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 20.4883,
    y1: 16.7187,
    x2: 32.5334,
    y2: 17.1845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C78D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#CF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#F3C36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F3C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9B559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#CE9326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 29.1133,
    y1: 29.7275,
    x2: 37.1408,
    y2: 30.0247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C78D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#CF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#F3C36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F3C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9B559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#CE9326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 20.0664,
    y1: 16.4487,
    x2: 32.81,
    y2: 16.9463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C78D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#CF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#F3C36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F3C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9B559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#CE9326"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmSeenFirst);
export default __webpack_public_path__ + "static/media/gm-seen-first.b196cf5fd0594c2e92cd6cbce49a9c51.svg";
export { ForwardRef as ReactComponent };